"use client"

import { useRouter } from "next/navigation"
import { useEffect } from "react"

type IProps = {
  to: string
  when: boolean
  deps?: any[]
}

export function useRedirect({ to, when, deps = [] }: IProps) {
  const router = useRouter()

  useEffect(() => {
    if (when) router.push(to)
  }, [...deps, when, to])
}
